module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADwSURBVDhPYxhwwAilGVat+s8MZRIFwsIY/4JosAEgzcIaH/6A2ESCz856gnwgBtiAoxc/i31n/JMOYhMLmP8yTHY0FPwA94JGxmkHKJMocGOG6QEQjTAg/fwVBob/2lAufsDIcOzGDCNrEJMJLAAETP//JgOpVxAeHvCf4TUj4/9iKA/hAhDQyLjgw/D/32YoFyv4z8AYcHOm4UYoF+ECELgxw2DLfwamJCgXC/ifjqwZBFAMAIGbMw3mA51VAeXCwX8GhtobM41nQblwgOIFZKCZfnYC0Ln5UO7kGzON8qBs4oF6+rkVIAzlDk/AwAAA/VZCpH7kYx0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/workOrder/Openicon.png
// module id = UWyY
// module chunks = 1